import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import Loader from 'components/Loader/Loader'
import useAuthHook from 'hooks/use-auth'
import { useGetUserProfile } from 'hooks/use-profile'
import {
  SAVE_USER_LAST_LOGIN_SESSION_MUTATION,
  SaveUserLastLoginSessionResponse,
  UpdateUserLastLoginSessionRequestInput,
} from 'queries/mutations/save-user-last-login'
import { useTokenExpiryHandler } from 'store/contexts/TokenExpWarn'

const SuccessSSO: React.FC = () => {
  const { setTokenExpiryTimeout } = useTokenExpiryHandler()
  const history = useHistory()
  const { isAuthenticated, user } = useAuthHook()
  const dealNumber = localStorage.getItem('dealNumber')
  const decisionType = localStorage.getItem('decisionType')
  const decisionReason = localStorage.getItem('decisionReason')
  const rawEmailId = localStorage.getItem('emailId')
  const emailId = rawEmailId === 'undefined' ? undefined : rawEmailId // Handle case where emailId is 'undefined'
  const redirectPath = localStorage.getItem('frompath')

  const [saveUserLastSession] = useMutation<
    SaveUserLastLoginSessionResponse,
    { input: UpdateUserLastLoginSessionRequestInput }
  >(SAVE_USER_LAST_LOGIN_SESSION_MUTATION)
  const { getUserProfile } = useGetUserProfile()

  useEffect(() => {
    if (user) {
      const { access_token, refresh_token, id_token } = user
      localStorage.setItem('authUserEmailAddress', user.profile.sub)
      localStorage.setItem('token', access_token ?? '')
      localStorage.setItem('id_token', id_token ?? '')
      localStorage.setItem('refresh_token', refresh_token ?? '')
      const userLoginCount = Number(localStorage.getItem('user_login') ?? 0) + 1
      localStorage.setItem('user_login', userLoginCount.toString())
      setTokenExpiryTimeout(access_token ?? '')

      const userEmail = user.profile.sub
      if (userEmail) {
        getUserProfile({ variables: { email: userEmail, client_id: 'price_hub' } })
          .then((res) => {
            const userId = res?.data?.userSecurityProfile?.securityProfile?.userProfile?.userId
            if (!userId) {
              console.error('SuccessSSO: userId not found in user profile response')
              return
            }
            saveUserLastSession({
              variables: {
                input: {
                  userId,
                },
              },
            }).catch((err) => {
              console.error('SuccessSSO: failed to save user last session', err)
            })
          })
          .catch((err) => {
            console.error('SuccessSSO: failed to fetch user profile', err)
          })
      }
    }
    if (redirectPath && isAuthenticated) {
      localStorage.removeItem('frompath') // clean up
      history.push(redirectPath)
    } else if (dealNumber && isAuthenticated) {
      const finalEmail = emailId ?? ''
      const finalUrl = `/workflow/${dealNumber}/${decisionType}/${decisionReason}/${finalEmail}`
      history.push(finalUrl)
    }
  }, [user, isAuthenticated, dealNumber])

  return <Loader open={true} />
}

export default SuccessSSO
